import './rugby.css';

const Rugby = () => {
    return (
        <a href='/rugby'>
            <div className="column rugby">
                <h2 className="title">RUGBY</h2>
            </div>
        </a>
    );
}

export default Rugby;